module.exports = __webpack_public_path__ + "static/media/negative_zole.7dbebfec.svg";